// src/shared/utils/mapApiError.js
export function mapApiError(err) {
  const status = err?.status;
  const data = err?.data;

  const message =
    err?.message ||
    data?.detail ||
    data?.message ||
    (typeof data === "string" ? data : null) ||
    "Ocurrió un error";

  return {
    status,
    message,
    data,
    isAuth: status === 401,
    isForbidden: status === 403,
    isNotFound: status === 404,
    isValidation: status === 422,
    isServer: status >= 500,
  };
}
